import { useGetClientInstrumentsData } from './hooks/useGetClientInstrumentsData';
import { useGetTransactionInitialData } from './hooks/useGetTransactionInitialData';

export enum BLACKLIST_PANS_DATA_VARIANT {
  CLIENT_INSTRUMENTS_DATA = 'clientInstrumentsData',
  TRANSACTION_DATA = 'transactionData',
}

export const initialDataHook = {
  [BLACKLIST_PANS_DATA_VARIANT.CLIENT_INSTRUMENTS_DATA]: useGetClientInstrumentsData,
  [BLACKLIST_PANS_DATA_VARIANT.TRANSACTION_DATA]: useGetTransactionInitialData,
};
